import classNames from "classnames/bind";
import styles from "./CategoryDetails.module.scss";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { URL } from "../../../routes/url";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeftLong } from "@fortawesome/free-solid-svg-icons";
import { callFetchCategoryByID } from "../../../config/api";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE } from "../../../utils/constants/timeFormat";
import AsidePost from "../AsidePost/AsidePost";
import { Card } from "antd";

const css = classNames.bind(styles);

function CategoryDetails() {
  const [detailCategory, setDetailCategory] = useState<any>({});
  const [loading, setLoading] = useState(false);
  // const [topic, setTopic] = useState<any>({});
  const { id }: any = useParams();
  const fetchCategoryById = async () => {
    setLoading(true);
    const result: any = await callFetchCategoryByID(id);
    if (result.data._id) {
      setDetailCategory(result.data);
      setLoading(false);
    } else {
      setLoading(true);
    }
  };

  useEffect(() => {
    fetchCategoryById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className={css("wrapper")}>
      <div className={css("content")}>
        {loading ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <Card loading={true}></Card>
            <Card loading={true}></Card>
            <Card loading={true}></Card>
          </div>
        ) : (
          <>
            <div className={css("content-title")}>
              <Link to={URL.CLIENT.POST} className={css("back_home")}>
                <FontAwesomeIcon icon={faLeftLong} size="1x" color="#1677ff" />
                <span>Xem thêm bài viết</span>
              </Link>
              <h1>{detailCategory?.title}</h1>
              <div className={css("topic-content")}>
                <p>Kể chuyện {detailCategory.name}</p>{" "}
                <span>
                  {" "}
                  <DateFormat
                    time={detailCategory.createdAt}
                    format={FORMAT_DATE}
                  />
                </span>
              </div>
              <img src={detailCategory?.image} alt="" />
            </div>
            <div className={`html_react_parser ${css("additional-class")}`}>
              {parse(detailCategory?.description || "")}
            </div>
          </>
        )}
      </div>

      <div className={css("sidebar")}>
        <AsidePost />
      </div>
    </div>
  );
}

export default CategoryDetails;
